import { DateTime } from 'ionic-angular/components/datetime/datetime';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { BarcodeScannerProvider } from '../../../providers/barcode-scanner-provider';

/**
 * Generated class for the StokeklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-stokekle',
  templateUrl: 'stokekle.html',
})
export class StokeklePage {
gununtarihi:any;
Stok:any={ID:-1,PLU:1,Price3:0,IsTerazi:1,Price4:0,Vat:8,VatGrupId:1,BirimId:1,MarkId:1,KategoriID:1,UlkeID:1};
vwUrun:any={};
BirimListesi=[];
KategoriListesi=[];
MarkaListesi=[];
KdvGrupListesi=[];
aranan = "";
skip: number = 0;
take: number = 50;
UlkeListesi=[];
YerliMi=false;
Terazi=false;
PLU=false;
Status=false;
barkodkontrolu:number;
//tarih1=this.ortak.storageGunTarihiGetir();

  constructor(private barcodeScanner: BarcodeScannerProvider,public navCtrl: NavController,public ortak:Ortak,public viewCtrl:ViewController,public bllOrtak:BllOrtak, public navParams: NavParams) {
   if(navParams.get("vwUrun")!=null){
     this.vwUrun=navParams.get("vwUrun");
     var data=new FormData();
     data.append("Stok_id",this.vwUrun.ID);
     this.bllOrtak.islem(data,"StokGetirByID","",false).then(a=>{
       var Sonuc=<any>a;
       this.Stok=Sonuc.SonucObject;
       this.Terazi=this.Stok.IsTerazi;
       this.PLU=this.Stok.PLU;
       this.Status=this.Stok.Status;
       
     }
    )
    
   }
  }

  ionViewDidLoad() {
   this.BirimGetir();
   this.MarkaGetir();
   this.KategoriGetir();
   this.Tarihgetir();
   this.KdvGetir();
  this.UlkeGetir();
  
  }
  kapat(){
    this.viewCtrl.dismiss();
  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      
      this.Stok.Barcode1 = sonuc.text;
     
     
    })
  }
barkodkontrol()
{
  var formData = new FormData();
   
 
  formData.append("Barkod_id", this.Stok.Barcode1);
  this.bllOrtak.islem(formData, "BarkodKontrol","", false).then(a => {
   
    var sonuc = <any>a;
    this.barkodkontrolu = sonuc.SonucObject;

  })
  }


    
  boslukKontrol() {
    
    var mesaj = "";
  

    if (this.Stok.StokAdi == null || this.Stok.StokAdi == "") {
      mesaj = mesaj + "Lütfen Stok adını giriniz. <br/>";
    }
    if (this.Stok.Barcode1 == null || this.Stok.StokAdi == this.barkodkontrolu) {
      mesaj = mesaj + "Lütfen Barkod numarsını giriniz. <br/>";
    }
  

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
    
    
    


  }
  yerlikontrol(){
    if(this.Stok.UlkeID==1)
    {
      this.Stok.YerliMi=1;
    }
    else
    this.Stok.YerliMi=0;
  }
  kaydet() {

    this.yerlikontrol();
   
    var formData = new FormData();
  
    if (this.boslukKontrol()) {
      formData.append("Stok_json", JSON.stringify(this.Stok,this.Stok.FiyatDegisimTarihi=this.gununtarihi));

      this.bllOrtak.islem(formData, "StokEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
        this.kapat();

      })
    }
    }
    Tarihgetir(){
      
           this.gununtarihi=new Date().toISOString();
    
    }
BirimGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "BirimListesi", "", false).then(a => {
   
    var sonuc = <any>a;
    this.BirimListesi = sonuc.SonucObject;

  })
}
KategoriGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
   
    var sonuc = <any>a;
    this.KategoriListesi = sonuc.SonucObject;

  })
}
UlkeGetir(){
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "Ulkeler", "", false).then(a => {
   
    var sonuc = <any>a;
    this.UlkeListesi = sonuc.SonucObject;

  })

}
MarkaGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "MarkaListesi", "", false).then(a => {
   
    var sonuc = <any>a;
    this.MarkaListesi = sonuc.SonucObject;

  })
}
KdvGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "KdvListesi", "", false).then(a => {
   
    var sonuc = <any>a;
    this.KdvGrupListesi = sonuc.SonucObject;

  })
}
}


// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stokekle/stokekle.ts